var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgAndroid = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  viewBox: "-147 -70 294 345"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "#a4c639"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#a",
  stroke: "#FFF",
  strokeWidth: 14.4
}), /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#c",
  transform: "scale(-1 1)"
}), /*#__PURE__*/React.createElement("g", {
  id: "c",
  stroke: "#FFF",
  strokeWidth: 7.2
}, /*#__PURE__*/React.createElement("rect", {
  width: 13,
  height: 86,
  x: 14,
  y: -86,
  rx: 6.5,
  transform: "rotate(29)"
}), /*#__PURE__*/React.createElement("rect", {
  id: "d",
  width: 48,
  height: 133,
  x: -143,
  y: 41,
  rx: 24
}), /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#d",
  x: 85,
  y: 97
})), /*#__PURE__*/React.createElement("g", {
  id: "a"
}, /*#__PURE__*/React.createElement("ellipse", {
  cy: 41,
  rx: 91,
  ry: 84
}), /*#__PURE__*/React.createElement("rect", {
  width: 182,
  height: 182,
  x: -91,
  y: 20,
  rx: 22
})))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
  fill: "#FFF",
  stroke: "#FFF",
  strokeWidth: 7.2
}, /*#__PURE__*/React.createElement("path", {
  d: "M-95 44.5H95"
}), /*#__PURE__*/React.createElement("circle", {
  cx: -42,
  r: 4
}), /*#__PURE__*/React.createElement("circle", {
  cx: 42,
  r: 4
}))));
export { SvgAndroid as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB2aWV3Qm94PSItMTQ3IC03MCAyOTQgMzQ1Ij4KPGcgZmlsbD0iI2E0YzYzOSI+Cjx1c2Ugc3Ryb2tlLXdpZHRoPSIxNC40IiB4bGluazpocmVmPSIjYiIgc3Ryb2tlPSIjRkZGIi8+Cjx1c2UgeGxpbms6aHJlZj0iI2EiIHRyYW5zZm9ybT0ic2NhbGUoLTEsMSkiLz4KPGcgaWQ9ImEiIHN0cm9rZT0iI0ZGRiIgc3Ryb2tlLXdpZHRoPSI3LjIiPgo8cmVjdCByeD0iNi41IiB0cmFuc2Zvcm09InJvdGF0ZSgyOSkiIGhlaWdodD0iODYiIHdpZHRoPSIxMyIgeT0iLTg2IiB4PSIxNCIvPgo8cmVjdCBpZD0iYyIgcng9IjI0IiBoZWlnaHQ9IjEzMyIgd2lkdGg9IjQ4IiB5PSI0MSIgeD0iLTE0MyIvPgo8dXNlIHk9Ijk3IiB4PSI4NSIgeGxpbms6aHJlZj0iI2MiLz4KPC9nPgo8ZyBpZD0iYiI+CjxlbGxpcHNlIGN5PSI0MSIgcng9IjkxIiByeT0iODQiLz4KPHJlY3Qgcng9IjIyIiBoZWlnaHQ9IjE4MiIgd2lkdGg9IjE4MiIgeT0iMjAiIHg9Ii05MSIvPgo8L2c+CjwvZz4KPGcgc3Ryb2tlPSIjRkZGIiBzdHJva2Utd2lkdGg9IjcuMiIgZmlsbD0iI0ZGRiI+CjxwYXRoIGQ9Im0tOTUgNDQuNWgxOTAiLz48Y2lyY2xlIGN4PSItNDIiIHI9IjQiLz48Y2lyY2xlIGN4PSI0MiIgcj0iNCIvPgo8L2c+Cjwvc3ZnPgo=";